module.exports = __webpack_public_path__ + "img/guide_order.28619f05.svg";